import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import ReactPaginate from 'react-paginate';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table,
} from 'reactstrap';
import { useSelector } from 'react-redux';

const ItemCategory = () => {
  //----------- REDUCE TOOLKIT -------
  const vendorState = useSelector((state) => state.vendorState);
  const branchState = useSelector((state) => state.branchState);
  const { user } = useSelector((state) => state.authState);

  const navigate = useNavigate();
  const [categoryTable, setCategoryTable] = useState([]);
  const [totalPage, setTotalPage] = useState(); // Current page for pagination

  const onHandleSearchKeyItem = (e) => {
    const value = e.target.value; // Assuming you're trying to get the value from an input field
    getCategoryData(1, 10, value);
  };

  const onHandleAddCategory = () => {
    navigate('/additemcategory');
  };

  const onHandleEditCategory = (id) => {
    let findArrayData = categoryTable.find((e) => e.id === id);

    navigate('/additemcategory', {
      state: {
        id: findArrayData?.id,
        // category_name: findArrayData?.category_name, category_content: findArrayData.category_content,
        // online_yn: findArrayData.online_yn,
        // category_image: findArrayData.category_image,

        // cate_type: findArrayData.cate_type,
        // cate_id_if_sub_Selected: findArrayData.cate_id_if_sub_Selected,
        // cate_name_if_sub_Selected: findArrayData.cate_name_if_sub_Selected,
        // super_cate_id: findArrayData.super_cate_id,
        // balance_sheet_id: findArrayData.balance_sheet_id,
        // balance_sheet_cate_name: findArrayData.balance_sheet_cate_name,
        // cate_vendor_id: findArrayData.cate_vendor_id,
        // cate_branch_id: findArrayData.cate_branch_id
      },
    });
  };

  const getCategoryData = async (
    page = 1,
    limit = 10,
    search = '',
    venderMstId,
  ) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          accept: 'application/json',
        },
      };

      // Build query string
      let queryParams = `api/CategoryMaster/allcategory?pageNo=${page}&limit=${limit}&searchKey=${search}`;
      // if (selectedVendorId) {
      //     queryParams += `&venderMasterId=${selectedVendorId}`; // fixed var name
      // }
      const vendorIdToUse = venderMstId || selectedVendorId;
      if (vendorIdToUse) {
        queryParams += `&venderMasterId=${vendorIdToUse}`;
      }

      if (selectedBranchId && !venderMstId) {
        queryParams += `&branchMasterId=${selectedBranchId}`; // fixed var name
      }

      const response = await apiService.get(queryParams, config);
      // const response = await apiService.get(`/api/CategoryMaster/allcategory?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        console.log(response.categoryMasterDetailData);
        setCategoryTable(response.categoryMasterDetailData);
        setTotalPage(response.totalPages);
        // toast.success(response.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(`SomeThing went wrong!!`);
    }
  };

  // useEffect(() => {
  //     getCategoryData();
  // }, [!categoryTable]);

  const handlePageClick = (data) => {
    getCategoryData(data.selected + 1);
  };

  const onHandleDeleteCategory = async (id) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );
    if (isDeleteConfirmed) {
      try {
        let config = {
          headers: {
            'Content-Type': 'application/json', // Important for file upload//s
            accept: 'application/json',
          },
        };

        const response = await apiService.delete(
          `api/CategoryMaster/delete?categoryId=${id}`,
          config,
        );
        if (response.response && response.response.data.errors) {
          toast.success(response.response?.data?.errors);
        }

        if (response.status === true) {
          toast.success(response.message);
          getCategoryData();
        } else {
          toast.success(response.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(`SomeThing went wrong!!`);
      }
    } else {
      console.log('Deletion canceled.');
    }
  };

  // =======================  VENDER & BRANCH =================

  const [selectedVendorId, setSelectedVendorId] = useState('');
  const [selectedBranchId, setSelectedBranchId] = useState('');

  // Handle vendor selection change
  const selectVendorFilter = (e) => {
    let value = e.target.value;
    if (!value) {
      setSelectedVendorId(value);
      setSelectedBranchId('');
    } else {
      setSelectedVendorId(value);
      setSelectedBranchId('');
      getCategoryData(1, 10, '', value);
    }
  };

  // Handle branch selection change
  const selectbranchFilter = (e) => {
    setSelectedBranchId(e.target.value);
  };

  // useEffect(() => {
  //     getCategoryData(1, 10, "")
  // }, [selectedVendorId, selectedBranchId])

  useEffect(() => {
    if (
      user.user_profile != 'superadmin' &&
      selectedVendorId &&
      selectedBranchId
    ) {
      getCategoryData(1, 10, '');
    } else if (user.user_profile == 'superadmin') {
      getCategoryData(1, 10, '');
    }

    if (vendorState.vendors.length == 1) {
      setSelectedVendorId(vendorState.vendors[0].id);
    }

    if (branchState.branches.length == 1) {
      setSelectedBranchId(branchState.branches[0].id);
    }
  }, [selectedVendorId, selectedBranchId]);

  return (
    <>
      <Col lg='12'>
        <Card className='bg-white pd-10 card-box mb-30'>
          {/* <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between toolbar-row sticky-top"> */}

          <CardTitle
            tag='h6'
            className='border-bottom p-3 mb-0 d-flex align-items-center justify-content-between sticky-top'
          >
            <Col>
              <Row className='align-items-center  g-0 mb-2'>
                <Col
                  xs={12}
                  className='d-flex justify-content-between align-items-center'
                >
                  {/* Title aligned left */}
                  <div className='d-flex align-items-center'>
                    <i className='bi bi-card-text mr-2'></i>
                    Item Category Master
                  </div>
                  <div className='d-flex justify-content-end mb-2'>
                    <Button
                      color='success'
                      onClick={onHandleAddCategory}
                      className='d-flex align-items-center'
                    >
                      <i className='bi bi-plus-circle mr-2'></i>
                      New
                    </Button>
                  </div>
                </Col>
              </Row>

              <Row style={{ display: 'flex', justifyContent: 'start' }}>
                <Col
                  xl={12}
                  md={6}
                  className='d-flex justify-content-center justify-content-md-end align-items-center gap-2'
                >
                  <Input
                    id='search'
                    name='search'
                    placeholder='Search...'
                    type='text'
                    // style={{ minWidth: '250px' }}
                    onChange={(e) => onHandleSearchKeyItem(e)}
                  />
                </Col>
              </Row>

              {/* <Row className="align-items-center" style={{ marginRight: '10px' }}>
                                <Input  id="search" name="search" placeholder="Search..." type="text" onChange={(e) => { onHandleSearchKeyItem(e) }} />
                            </Row> */}

              <Row
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: 10,
                }}
              >
                {/* Vendor Filter */}
                {(vendorState?.vendors.length === 0 ||
                  vendorState?.vendors.length > 1) && (
                  <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                    <FormGroup>
                      <label
                        style={{ fontWeight: 'bold', marginBottom: '5px' }}
                      >
                        Vendor
                      </label>
                      <Input
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          padding: '6px 12px',
                        }}
                        type='select'
                        className='custom-select'
                        name='selectedVendorId'
                        value={selectedVendorId}
                        onChange={selectVendorFilter}
                      >
                        <option value=''>-- Select Vendor --</option>
                        {vendorState?.vendors.map((data) => (
                          <option key={data.id} value={data.id}>
                            {data.vender_name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                )}

                {/* Branch Filter */}
                {(branchState?.branches?.length === 0 ||
                  branchState?.branches?.length > 1) && (
                  <Col xl={3} md={4} sm={6} style={{ marginBottom: '15px' }}>
                    <FormGroup>
                      <label
                        style={{ fontWeight: 'bold', marginBottom: '5px' }}
                      >
                        Branch
                      </label>
                      <Input
                        style={{
                          border: '1px solid #ced4da',
                          borderRadius: '4px',
                          padding: '6px 12px',
                        }}
                        type='select'
                        className='custom-select'
                        name='selectedBranchId'
                        value={selectedBranchId}
                        onChange={selectbranchFilter}
                        disabled={!selectedVendorId}
                      >
                        <option value=''>-- Select Branch --</option>
                        {branchState?.branches
                          ?.filter(
                            (data) =>
                              selectedVendorId
                                ? String(data.vender_master_id) ===
                                  String(selectedVendorId)
                                : true, // Show all branches if no vendor is selected
                          )
                          .map((data) => (
                            <option key={data.id} value={data.id}>
                              {data.branch_name}
                            </option>
                          ))}
                      </Input>
                    </FormGroup>
                  </Col>
                )}
              </Row>
            </Col>

            {/* <Button color="primary" size="bg" onClick={onHandleAddCategory}>Add</Button> */}
          </CardTitle>

          <CardBody>
            <div className='table-responsive'>
              <Table hover striped responsive>
                <thead>
                  <tr>
                    <th>S. no.</th>
                    {(user.user_profile == 'superadmin' ||
                      branchState.length) && <th>Branch/Vendor Name</th>}
                    <th>Category/Group Name</th>
                    <th>Main/Sub</th>
                    <th>Main Categroy Name</th>
                  </tr>
                </thead>
                <tbody>
                  {categoryTable.map((item, index) => (
                    <tr key={index}>
                      {/* <th scope="row">{index + 1}</th> */}

                      <th scope='row'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start',
                            flexDirection: 'column',
                          }}
                        >
                          <span className='ms-2'>{index + 1}</span>

                          <Button
                            color='warning'
                            className='me-0 ms-2'
                            size='sm'
                            onClick={() => onHandleEditCategory(item.id)}
                          >
                            <p
                              style={{
                                fontSize: 12,
                                padding: 0,
                                margin: 0,
                                fontWeight: 'bold',
                              }}
                            >
                              <i className='bi bi-pencil mr-1'></i>Edit
                            </p>
                          </Button>
                        </div>
                      </th>
                      {(user.user_profile == 'superadmin' ||
                        branchState.length) && (
                        <td>
                          {' '}
                          {item.branch_name} ***** <br></br>
                          {item.vender_name}
                        </td>
                      )}
                      <td>{item.category_name}</td>
                      <td>{item.cate_type}</td>
                      <td>{item.cate_name_if_sub_selected}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </CardBody>

          <CardBody>
            {/* <ReactPaginate
                            previousLabel={'Previous'}
                            nextLabel={'Next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                        // forcePage={currentPage} // keeps pagination in sync

                        /> */}

            <ReactPaginate
              previousLabel={'Previous'}
              nextLabel={'Next'}
              breakLabel={'...'}
              pageCount={totalPage} // still 4000
              marginPagesDisplayed={1} // 1 page at start & end
              pageRangeDisplayed={2} // visible range around selected page
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              activeClassName={'active'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              nextClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
            />

            {/* <ReactPaginate
                            previousLabel={'←'}
                            nextLabel={'→'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={totalPage}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageClick}
                            containerClassName={'pagination'}
                            activeClassName={'active'}
                            disabledClassName={'disabled'}
                            previousClassName={'previous'}
                            nextClassName={'next'}
                        /> */}
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default ItemCategory;
